import React from 'react';
import {
  makeStyles,
  Typography,
  useTheme,
} from '@material-ui/core';
import { string, func, bool } from 'prop-types';
import { Grid } from '@material-ui/core';
import FormButton from '../../FormButton';

const useStyles = makeStyles(
  ({ spacing, fonts, breakpoints: { down } }) => ({
    container: {
      paddingBottom: ({ showButton }) =>
        showButton ? spacing(5) : spacing(15),
    },
    title: {
      marginBottom: spacing(4),
      [down('xs')]: {
        fontSize: fonts.size.l,
        whiteSpace: 'pre-line',
      },
    },
    description: {
      whiteSpace: 'break-spaces',
      [down('xs')]: {
        fontSize: fonts.size.xxs,
      },
    },
  })
);

const FeedbackMessage = ({
  title,
  description,
  buttonText,
  action,
  showButton = true,
  ...props
}) => {
  const theme = useTheme();
  const classes = useStyles({ ...theme, showButton });

  return (
    <Grid
      container
      direction="column"
      className={classes.container}
      {...props}
    >
      <Typography variant="h2" className={classes.title}>
        {title}
      </Typography>
      <Typography className={classes.description}>
        {description}
      </Typography>
      {showButton && (
        <Grid container item justify="center">
          <FormButton
            title={buttonText}
            tailed={true}
            isDisabled={false}
            inverted={true}
            buttonType="button"
            onClick={action}
          />
        </Grid>
      )}
    </Grid>
  );
};

FeedbackMessage.propTypes = {
  title: string,
  description: string,
  buttonText: string,
  action: func,
  showButton: bool,
};

export default FeedbackMessage;
